let baseUrl;
if (process.env.NODE_ENV === 'production') {
    // TODO: replace with production API URL
    baseUrl = '/api/user/';
} else {
    baseUrl = 'http://127.0.0.1:8000/api/user/';
}

export const CONNECTION_TYPE = {
    api_key: 'api_key',
    oauth: 'oauth',
    private_key_file: 'private_key_file',
};

export const PROVIDERS = {
    openai: 'openai',
    anthropic: 'anthropic',
    perplexity: 'perplexity',
    // weaviate: 'weaviate',
    hubspot: 'hubspot',
    serper: 'serper',
    fireflies: 'fireflies',
    notion: 'notion',
    airtable: 'airtable',
    ayrshare: 'ayrshare',
    // asana: 'asana',
    apify: 'apify',
    slack: 'slack',
    google: 'google',
    github: 'github',
    rapidapi: 'rapidapi',
    firecrawl: 'firecrawl',
    smartscout: 'smartscout',
    clickup: 'clickup',
    google_cloud: 'google-cloud',
    anymail_finder: 'anymail-finder',
};

export const PROVIDERS_LABEL = {
    [PROVIDERS.openai]: 'OpenAI',
    [PROVIDERS.anthropic]: 'Anthropic',
    // [PROVIDERS.weaviate]: 'Weaviate',
    [PROVIDERS.perplexity]: 'Perplexity',
    [PROVIDERS.hubspot]: 'HubSpot',
    [PROVIDERS.serper]: 'Serper API',
    [PROVIDERS.fireflies]: 'Fireflies',
    [PROVIDERS.notion]: 'Notion',
    [PROVIDERS.airtable]: 'Airtable',
    [PROVIDERS.ayrshare]: 'Ayrshare',
    // [PROVIDERS.asana]: 'Asana',
    [PROVIDERS.apify]: 'Apify',
    [PROVIDERS.slack]: 'Slack',
    [PROVIDERS.google]: 'Google LLM',
    [PROVIDERS.github]: 'GitHub',
    [PROVIDERS.rapidapi]: 'Rapid API',
    [PROVIDERS.firecrawl]: 'Firecrawl',
    [PROVIDERS.smartscout]: 'SmartScout',
    [PROVIDERS.clickup]: 'ClickUp',
    [PROVIDERS.google_cloud]: 'Google Cloud',
    [PROVIDERS.anymail_finder]: 'Anymail Finder',
};

export const PROVIDERS_LOGO = {
    [PROVIDERS.openai]: '/images/providers-logo/openai-logo.png',
    [PROVIDERS.anthropic]: '/images/providers-logo/anthropic-logo.png',
    [PROVIDERS.perplexity]: '/images/providers-logo/perplexity-logo.png',
    // [PROVIDERS.weaviate]: '/images/providers-logo/weaviate-logo.png',
    [PROVIDERS.hubspot]: '/images/providers-logo/hubspot-logo.png',
    [PROVIDERS.serper]: '/images/providers-logo/serper-logo.png',
    [PROVIDERS.fireflies]: '/images/providers-logo/fireflies-logo.png',
    [PROVIDERS.notion]: '/images/providers-logo/notion-logo.png',
    [PROVIDERS.airtable]: '/images/providers-logo/airtable-logo.png',
    [PROVIDERS.ayrshare]: '/images/providers-logo/ayrshare-logo.png',
    // [PROVIDERS.asana]: '/images/providers-logo/asana-logo.png',
    [PROVIDERS.apify]: '/images/providers-logo/apify-logo.png',
    [PROVIDERS.slack]: '/images/providers-logo/slack-logo.png',
    [PROVIDERS.google]: '/images/providers-logo/google-logo.png',
    [PROVIDERS.github]: '/images/providers-logo/github-logo.png',
    [PROVIDERS.rapidapi]: '/images/providers-logo/rapidapi-logo.png',
    [PROVIDERS.firecrawl]: '/images/providers-logo/firecrawl-logo.png',
    [PROVIDERS.smartscout]: '/images/providers-logo/smartscout-logo.png',
    [PROVIDERS.clickup]: '/images/providers-logo/clickup-logo.png',
    [PROVIDERS.google_cloud]: '/images/providers-logo/google-cloud-logo.png',
    [PROVIDERS.anymail_finder]: '/images/providers-logo/anymail-finder-logo.png',
};

export const providersCardData = {
    [PROVIDERS.openai]: {
        title: PROVIDERS_LABEL[PROVIDERS.openai],
        description: 'Connect your OpenAI API key to run your prompts using their models.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.openai],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.anthropic]: {
        title: PROVIDERS_LABEL[PROVIDERS.anthropic],
        description: 'Connect your Anthropic API key to run your prompts using their models.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.anthropic],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.perplexity]: {
        title: PROVIDERS_LABEL[PROVIDERS.perplexity],
        description: 'Connect your Perplexity API key to run your prompts using their models.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.perplexity],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.google]: {
        title: PROVIDERS_LABEL[PROVIDERS.google],
        description: 'Connect your Google Gemini API key to run your prompts using their models.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.google],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    // [PROVIDERS.weaviate]: {
    //     title: PROVIDERS_LABEL[PROVIDERS.weaviate],
    //     description:
    //         'Connect your Weaviate cluster to start embedding your business knowledge into a vector store.',
    //     logoPath: PROVIDERS_LOGO[PROVIDERS.weaviate],
    // },
    [PROVIDERS.hubspot]: {
        title: PROVIDERS_LABEL[PROVIDERS.hubspot],
        description: 'Connect your HubSpot account to reimagine your sales and marketing efforts.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.hubspot],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.serper]: {
        title: PROVIDERS_LABEL[PROVIDERS.serper],
        description:
            'Connect your Serper API account to supercharge your processes with real-time web search capabilities.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.serper],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.fireflies]: {
        title: PROVIDERS_LABEL[PROVIDERS.fireflies],
        description: 'Connect your Fireflies account to enhance your meeting productivity.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.fireflies],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.notion]: {
        title: PROVIDERS_LABEL[PROVIDERS.notion],
        description:
            'Connect your Notion account to amplify your collaboration and organization capabilities.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.notion],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.airtable]: {
        title: PROVIDERS_LABEL[PROVIDERS.airtable],
        description:
            'Connect your Airtable account to connect your business processes to your data.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.airtable],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.ayrshare]: {
        title: PROVIDERS_LABEL[PROVIDERS.ayrshare],
        description:
            'Connect your Ayrshare account to connect your social media accounts for content processes.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.ayrshare],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    // [PROVIDERS.asana]: {
    //     title: PROVIDERS_LABEL[PROVIDERS.asana],
    //     description:
    //         'Connect your Asana account to bring your processes into the personal productivity space.',
    //     logoPath: PROVIDERS_LOGO[PROVIDERS.asana],
    // },
    [PROVIDERS.rapidapi]: {
        title: PROVIDERS_LABEL[PROVIDERS.rapidapi],
        description: 'Connect your Rapid API account to supercharge your processes with new APIs.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.rapidapi],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.slack]: {
        title: PROVIDERS_LABEL[PROVIDERS.slack],
        description:
            'Connect your Slack account to streamline your team’s collaboration and communication.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.slack],
        authUrl: `oauth/redirect/?provider=slack`,
        connectionType: CONNECTION_TYPE.oauth,
    },
    [PROVIDERS.apify]: {
        title: PROVIDERS_LABEL[PROVIDERS.apify],
        description:
            'Connect your Apify account to unlock web scraping and automation capabilities.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.apify],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.google_cloud]: {
        title: PROVIDERS_LABEL[PROVIDERS.google_cloud],
        description:
            'Connect your Google Cloud Service key to give DiviUp access to your Google Drive.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.google_cloud],
        authUrl: null, // note - we will want to add service key json file upload option later
        connectionType: CONNECTION_TYPE.private_key_file,
    },
    [PROVIDERS.github]: {
        title: PROVIDERS_LABEL[PROVIDERS.github],
        description:
            'Connect your GitHub account to work with your repositories and automate your workflows.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.github],
        authUrl: `oauth/redirect/?provider=github`,
        connectionType: CONNECTION_TYPE.oauth,
    },
    [PROVIDERS.firecrawl]: {
        title: PROVIDERS_LABEL[PROVIDERS.firecrawl],
        description: 'Connect your Firecrawl account to unlock smarter web scraping and crawling.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.firecrawl],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.smartscout]: {
        title: PROVIDERS_LABEL[PROVIDERS.smartscout],
        description: 'Connect your SmartScout account to leverage Amazon data.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.smartscout],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.clickup]: {
        title: PROVIDERS_LABEL[PROVIDERS.clickup],
        description: 'Connect your ClickUp account to manage your tasks and projects.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.clickup],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
    [PROVIDERS.anymail_finder]: {
        title: PROVIDERS_LABEL[PROVIDERS.anymail_finder],
        description: 'Connect your Anymail Finder account to find and verify email addresses.',
        logoPath: PROVIDERS_LOGO[PROVIDERS.anymail_finder],
        authUrl: null,
        connectionType: CONNECTION_TYPE.api_key,
    },
};

export const providersForNonAgencyOrg = [PROVIDERS.openai, PROVIDERS.anthropic];

export const providersForAgencyOrg = [
    PROVIDERS.openai,
    PROVIDERS.anthropic,
    PROVIDERS.perplexity,
    PROVIDERS.google,
    // PROVIDERS.weaviate,
    PROVIDERS.hubspot,
    PROVIDERS.serper,
    PROVIDERS.fireflies,
    PROVIDERS.notion,
    PROVIDERS.airtable,
    PROVIDERS.ayrshare,
    // PROVIDERS.asana,
    PROVIDERS.apify,
    PROVIDERS.slack,
    PROVIDERS.rapidapi,
    PROVIDERS.firecrawl,
    PROVIDERS.smartscout,
    PROVIDERS.clickup,
    PROVIDERS.google_cloud,
    PROVIDERS.anymail_finder,
];

export const comingSoonProviders = [];
